function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#67BBB0",
  d: "M0,80C0,35.817,35.817,0,80,0s80,35.817,80,80c0,44.183-35.817,80-80,80S0,124.183,0,80"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M111.337,42.25h-55.93c-1.518,0-2.75,1.231-2.75,2.75v5.231h-3.994c-1.518,0-2.75,1.232-2.75,2.75 c0,1.519,1.232,2.75,2.75,2.75h3.994v7.982h-3.994c-1.518,0-2.75,1.232-2.75,2.75c0,1.519,1.232,2.75,2.75,2.75h3.994v7.982h-3.994 c-1.518,0-2.75,1.232-2.75,2.75c0,1.52,1.232,2.75,2.75,2.75h3.994v7.982h-3.994c-1.518,0-2.75,1.231-2.75,2.75 s1.232,2.75,2.75,2.75h3.994v7.981h-3.994c-1.518,0-2.75,1.232-2.75,2.75c0,1.52,1.232,2.75,2.75,2.75h3.994V115 c0,1.519,1.232,2.75,2.75,2.75h55.93c1.52,0,2.75-1.231,2.75-2.75V45C114.087,43.481,112.856,42.25,111.337,42.25 M108.587,112.25 h-50.43v-2.592h3.913c1.519,0,2.75-1.23,2.75-2.75c0-1.518-1.231-2.75-2.75-2.75h-3.913v-7.981h3.913c1.519,0,2.75-1.231,2.75-2.75 s-1.231-2.75-2.75-2.75h-3.913v-7.982h3.913c1.519,0,2.75-1.23,2.75-2.75c0-1.518-1.231-2.75-2.75-2.75h-3.913v-7.982h3.913 c1.519,0,2.75-1.231,2.75-2.75c0-1.518-1.231-2.75-2.75-2.75h-3.913v-7.982h3.913c1.519,0,2.75-1.231,2.75-2.75 c0-1.518-1.231-2.75-2.75-2.75h-3.913V47.75h50.43V112.25z"
});

var SvgAdempimentiAccent = function SvgAdempimentiAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.349 -0.917 161 161",
    enableBackground: "new -0.349 -0.917 161 161",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdempimentiAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adempimenti_accent.483c44a3.svg";
export { ForwardRef as ReactComponent };